export default "__VITE_ASSET__b9ab4344__"